

























































































































































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import FileUploader from "@/components/FileUploader.vue";
import Page from "@/views/Page.vue";
import IFamily from "../../models/interfaces/IFamily";
import FamiliesMixin from "../../mixins/http/FamiliesMixin";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import VCheckbox from "@/components/VCheckbox.vue";

import { showToast } from "../../utils/RailsRoutes";
@Component({ components: { Page, FileUploader, VCheckbox } })
export default class FamilyCreate extends Mixins(FamiliesMixin) {
  private family: IFamily = {
    code: null,
    name: null,
    descriptionIt: null,
    descriptionEn: null,
    generic: false,
  };

  static readonly createFamilytag = "create_family_tag";
  @RegisterHttp(FamilyCreate.createFamilytag) createFamilyRequest: RequestData;

  private logo = null;
  private attachments = [];

  get loading() {
    return this.createFamilyRequest?.loading;
  }

  get valid() {
    return (
      this.family.code &&
      this.family.descriptionIt &&
      this.family.descriptionEn &&
      this.family.name
    );
  }

  openFiles() {
    const file = (this.$refs.upload as any).openFileBrowser();
  }

  createPayload() {
    let payload = new FormData();
    for (const key in this.family) {
      if (this.family[key] !== null && this.family[key] !== undefined) {
        payload.append(key, this.family[key]);
      }
    }
    if (this.logo) {
      payload.append("icon", this.logo.file);
    }

    for (const attachment of this.attachments) {
      payload.append("attachments[]", attachment.file);
    }

    return payload;
  }

  removeAttachment(index) {
    this.attachments.splice(index, 1);
  }

  onCreate() {
    const payload = this.createPayload();
    this.createFamily(payload, FamilyCreate.createFamilytag).then(
      (resp) => {
        showToast(`Family ${resp.name} created successfully`);
        this.$router.back();
      },
      (err) => {
        const message = err?.response?.data?.message || err.message;
        showToast(`An error occurred while creating the family. ${message}`, {
          type: "error",
        });
      }
    );
  }
}
